module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('privacy-terms-component'), _vm._v(" "), _c('privacy-service-component')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5987d9c9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userAgreement/UserAgreement.vue
// module id = 1326
// module chunks = 1